// eslint-disable-next-line no-unused-vars
import React, { useContext } from "react";
// eslint-disable-next-line no-unused-vars
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./Auth.js";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const { currentUser } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        currentUser ? (
          <RouteComponent {...routeProps} />
        ) : (
          <div>
            <Redirect to={"/"} />
          </div>
        )
      }
    />
  );
};

export default PrivateRoute;
